export class GeocoderResponseModel {
  public status: string;
  public error_message: string = '';
  public results: google.maps.GeocoderResult[] | null;

  constructor(status: string, results: google.maps.GeocoderResult[] | null) {
    this.status = status;
    this.results = results;
  }
}
